import { AnimatedPage } from "../components/AnimatedPage";
import { CTASection } from "../components/CTASection";
import { FeatureCard } from "../components/FeatureCard";
import { PageHero } from "../components/PageHero";
import { Section } from "../components/Section";
import { process, services } from "../data/site";

export default function Services() {
  return (
    <AnimatedPage>
      <PageHero
        eyebrow="Services"
        title="Premium software development services for every stage of growth"
        description="Build a fresh digital presence, ship a mobile product, modernize operations, or launch a full SaaS platform with a team that understands business software."
      />
      <Section
        eyebrow="Capabilities"
        title="Everything your digital product needs"
        description="Each service can stand alone or combine into a complete end-to-end product delivery engagement."
      >
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {services.map((service, index) => (
            <FeatureCard key={service.title} {...service} index={index} />
          ))}
        </div>
      </Section>
      <Section
        eyebrow="Delivery process"
        title="Structured execution without slowing momentum"
        description="A clear operating rhythm keeps strategy, design, engineering, launch, and support connected."
        className="bg-white/[0.025]"
      >
        <div className="grid gap-4 md:grid-cols-5">
          {process.map((item, index) => (
            <article key={item.title} className="glass-card p-5">
              <span className="text-sm font-semibold text-electric">
                0{index + 1}
              </span>
              <h3 className="mt-5 font-display text-lg font-semibold text-white">
                {item.title}
              </h3>
              <p className="mt-3 text-sm leading-6 text-white/60">
                {item.description}
              </p>
            </article>
          ))}
        </div>
      </Section>
      <CTASection />
    </AnimatedPage>
  );
}
